<template>
  <div class="con-tab-ejemplo">
    <vs-row>
      <!-- <pre>{{question_details}}</pre> -->
      <vs-col
        vs-offset="0"
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-w="12"
      >
        <vx-card title="Select View" class="mb-4">
          <vs-row>
            <subject-listing
              @SearchCourseEvent="seachOvaralll"
              @filterSubjectEvent="filterBySubject"
            ></subject-listing>
            <vs-col
              vs-lg="2"
              vs-sm="12"
              vs-xs="12"
              vs-type="flex"
              vs-justify="flex-end"
              class="p-1"
            >
              <vs-button
                @click="reditectToCreateNewView()"
                type="filled"
                v-if="checkingCreatePermission(questionApplicationType)"
                >Create</vs-button
              >
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>

      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-w="12"
      >
        <vs-card class="cstm_vx_card">
          <!-- {{question_details}} -->
          <!-- <div slot="header">
            <h3>Question</h3>
          </div> -->

          <vs-sidebar
            position-right
            parent="body"
            default-index="1"
            color="primary"
            class="sidebarx"
            spacer
            v-model="active"
          >
            <div class="header-sidebar" slot="header">
              <h4>Filter</h4>
            </div>

            <div class="footer-sidebar p-2" slot="footer">
              <vs-button color="primary" type="border">Done</vs-button>
            </div>
          </vs-sidebar>

          <!-- <div slot="header">
            <div class="flex flex-wrap items-center">
              <div class="p-1 xl:w-11/12 w-full">
                <v-select
                  class="w-full"
                  label="name"
                  placeholder="Enter tags to search"
                  :reduce="(option) => option.id"
                  :options="tagModuleWise"
                  v-model="tagSearch"
                  :clearable="false"
                  data-vv-name="tag_list"
                  name="tag_list"
                  multiple
                ></v-select
                >
              </div>
              <div class="p-1 xl:w-1/12 w-full text-left xl:text-right">
                <vs-button class="w-full" @click="tagSearchWise">Search</vs-button>
              </div>
            </div>
          </div> -->
          <!-- {{questionApplicationType}}
{{checkingDeletePermission(questionApplicationType)}} -->
          <div
            class="text-right"
            v-if="
              isRowSelected && checkingDeletePermission(questionApplicationType)
            "
          >
            <div class="bulk_holder">
              <a @click="bulkDelete">
                Bulk Delete
              </a>
            </div>
          </div>
          <!-- <vs-button
            v-if="selectedLength && checkingDeletePermission(questionApplicationType)"
            icon-pack="feather"
            style="float: right"
            @click="bulkDelete"
            color="danger"
            icon="icon-trash-2"
            >Bulk Deletes</vs-button
          > -->

          <!-- table -->
          <ag-grid-vue
            :frameworkComponents="frameworkComponents"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :tooltipMouseTrack="true"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="rowData"
            rowSelection="multiple"
            :enableRtl="$vs.rtl"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            @grid-ready="onGridReady"
            @row-selected="CellvalueSelectDeselect"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>
          <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-w="4"
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
            >
              <ItemsPerTableDropdown
                tableName="question_bank_data"
                @change="pageLimit => (pageLimitSet = pageLimit)"
              />
            </vs-col>
            <pagination
              :meta="meta"
              @page-change="handlePageChange"
              class="ml-auto"
            />
          </vs-row>
          <!-- <vs-table
            class="cstm_vuexy_table"
            multiple
            v-model="selected"
            :data="question_details"
            stripe
          >


            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  {{ data[indextr].question_title }}
                </vs-td>

                <vs-td>
                  {{ data[indextr].input_type_id_obj.field_type }}
                </vs-td>

                <vs-td>
                  {{ data[indextr].point }}
                </vs-td>
                <vs-td>
                  {{ data[indextr].subject.subject_name }}
                </vs-td>

                <vs-td v-if="data[indextr].file != null">
                  {{ data[indextr].file.length }}
                </vs-td>

                  <vs-td v-if="checkingEditPermission(questionApplicationType)">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-edit"
                      @click.stop="openEditView(data[indextr])"
                    ></vs-button>
                  </vs-td>
                  <vs-td v-if="checkingDeletePermission(questionApplicationType)">
                    <vs-button
                      icon-pack="feather"
                      color="danger"
                      icon="icon-trash-2"
                      @click.stop="openConfirm(data[indextr].id, data[indextr])"
                    ></vs-button>
                  </vs-td>
                  <vs-td>
                    <div class="switch-container mr-2">
                      <div class="center con-switch">
                        <vs-switch
                          @click.stop="
                            changeStatus(
                              data[indextr].status,
                              data[indextr].id,
                              indextr
                            )
                          "
                          class="vs-switch-success"
                          v-model="data[indextr].status"
                        />
                      </div>
                    </div>

                  </vs-td>
                <vs-td v-if="checkSharePermission() && questionApplicationType === 'General'">
                  <span
                    class="material-icons share-rotate"
                    @click="
                      sharingQuestion(
                        data[indextr].id,
                        data[indextr].sharedUserList
                      )"
                    >reply</span
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pagination
            :meta="meta"
            v-if="question_details.length > 0"
            @page-change="handlePageChange"
            style="float: right"
          /> -->
        </vs-card>
      </vs-col>
    </vs-row>

    <div v-if="sharePopUp">
      <vs-popup class="holamundo" title="Staff List" :active.sync="sharePopUp">
        <user-info-modal
          :question_id="sharedQuestionId"
          :sharedUserList="sharedUserList"
          Modaltype="QuestionBank"
          @updateUserId="updateUserId"
        ></user-info-modal>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import CustomTooltip from '@/views/pages/v1/coursework/components/CourseWork/customTooltipVue.js'
import CourseSubjectComponent from '@/views/pages/v1/coursework/components/CourseWork/SubjectComponent.vue'

import CellRendererQuestionAction from './CellRendererQuestionAction.vue'
import CellActiveRender from './CellActiveRender.vue'
import { AgGridVue } from 'ag-grid-vue'
import Vue from 'vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import vSelect from 'vue-select'
import {
  fetchQuestionBank,
  deleteQuestionById,
  changeQuestionStatusById
} from '@/api/question-bank'
import Pagination from '@/components/common/pagination'
import { Subject } from '@/mixins/subject/subject'
import subjectListing from '@/views/pages/v1/lesson/subjectListing.vue'
import { Tag } from '@/mixins/tag/tag'
import { PermissionMiddleware } from '../../../../mixins/middleware/PermissionMiddleware'
import { checkingAssignment } from '../../../../mixins/middleware/checkingAssignment'

import userInfoModal from '../../../../components/assignmentList/userInfoModal.vue'

export default {
  components: {
    Pagination,
    subjectListing,
    vSelect,
    userInfoModal,
    Vue,
    AgGridVue,
    CourseSubjectComponent,
    CustomTooltip,
    CellActiveRender,
    CellRendererQuestionAction
  },
  props: {
    questionApplicationType: {
      type: String,
      required: true
    }
  },
  beforeMount () {
    this.tooltipShowDelay = 0
    this.frameworkComponents = {
      customTooltip: CustomTooltip
    }
    this.columnDefs = [
      {
        headerName: '',
        minWidth: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 60,
        resizable: true,
        editable: false,
        sortable: false,
        valueGetter: (params) => {
          return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
        }
      },
      {
        headerName: 'Question Title',
        field: 'question_title',
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false,
        sortable: true
        // comparator:(valueA) => {}
      },
      {
        headerName: 'Question Type',
        field: 'input_type_id_obj.field_type',
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false
        // comparator:(valueA) => {}
      },
      {
        headerName: 'Subject',
        colId: 'subject_column',
        field: 'subject',
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false,
        // comparator:(valueA) => {},
        tooltipField: 'subject',
        tooltipComponentParams: { color: '#fff' },
        floatingFilterComponentParams: {
          suppressFilterButton: false
        },
        cellRendererFramework: Vue.extend(CourseSubjectComponent)
      },
      {
        headerName: 'Question Point',
        field: 'point',
        filter: true,
        minWidth: 120,
        resizable: true,
        editable: false
      },
      {
        headerName: 'No.of Files',
        field: 'file.length',
        filter: true,
        minWidth: 120,
        resizable: true,
        editable: false
      },
      {
        headerName: 'Active',
        field: 'active',
        minWidth: 100,
        sortable: false,
        resizable: true,
        editable: false,
        cellRendererFramework: Vue.extend(CellActiveRender),
        filterParams: {
          changeStatus: this.changeStatus
        }
      },
      {
        headerName: 'Actions',
        field: 'actions',
        minWidth: 100,
        maxWidth: 160,
        sortable: false,
        resizable: true,
        editable: false,
        cellRendererFramework: Vue.extend(CellRendererQuestionAction),
        filterParams: {
          openEditView: this.openEditView,
          openConfirm: this.openConfirm,
          sharingQuestion: this.sharingQuestion
        }
      }
    ]
  },
  data () {
    return {
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      gridOptions: {
        accentedSort: true
      },
      isRowSelected: false,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      pageLimitSet: 5,
      frameworkComponents: null,
      columnDefs: [],
      gridApi: null,

      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true,
        tooltipComponent: 'customTooltip'
        // autoHeight: true
      },
      rowData: [],

      search: '',
      sharePopUp: false,
      subject_id: [],
      selected: [],
      active1: '',
      active: false,
      select_filter_id: '',
      question_details: [],
      delete_id: [],
      sharedQuestionId: null,
      sharedUserList: [],
      tagSearch: []
    }
  },
  mixins: [Subject, Tag, PermissionMiddleware, checkingAssignment],
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    this.fetchTag((this.platform_module_id = 3))
    this.fetchSubjectList()
  },
  computed: {
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  created () {
    //this.checkingQuery('/pages/questionbanklist')

    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Question Bank')
    }
  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId === 'question_title') {
        field_name = 'title'
      } else if (colId === 'input_type_id_obj.field_type') {
        field_name = 'question_type'
      } else if (colId === 'subject_column') {
        field_name = 'subject'
      } else if (colId === 'file.length') {
        field_name = 'no_of_files'
      }
      console.log('field_name : ', field_name)
      return field_name
    },
    async sortFun () {
      try {
        const sortState = this.gridApi.getSortModel()
        if (sortState.length === 0) {
          this.sorting_obj = {
            field_type: '',
            attribute: '',
            direction: ''
          }
        } else {
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.sorting_obj.field_type = 'system'
        }
        this.fetchQuestionBankList()
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      //
      return selectedData
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    seachOvaralll (search) {
      this.search = search
      this.fetchQuestionBankList()
    },
    tagSearchWise () {
      this.subject_id = false
      this.tag_ids = this.tagSearch
      this.fetchQuestionBankList()
    },
    filterBySubject (subject_id) {
      this.tagSearch = []
      this.subject_id = subject_id
      this.fetchQuestionBankList()
    },
    openEditView (question) {
      this.$router.push({
        name: 'Edit QuestionsV2',
        params: {
          assignment_id:question.id,
          formType: 'Edit',
          type:'Question',
          redirection_from:1,
          assignmentApplicationType: this.questionApplicationType
        }
      })
    },
    reditectToCreateNewView () {
      //setTimeout(function(){
      this.$router.push({
        name: 'QuestionsV2',
        params: {
          formType: 'Create',
          type:'Question',
          redirection_from:1,
          assignmentApplicationType: this.questionApplicationType
        }
      })
      //},3000)
    },

    async fetchQuestionBankList () {
      try {
        this.$vs.loading()

        const customerId = this.$store.getters.customerId
        const payload = {
          subject_id: this.subject_id,
          tag_ids: this.tag_ids
        }

        if (this.questionApplicationType === 'General') {
          payload.custom = 0
        }

        if (this.questionApplicationType === 'Custom') {
          // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          // payload.user_id = userInfo.id

          payload.custom = 1
        }

        if (this.questionApplicationType === 'Shared') {
          payload.shared_course = true
        }
        payload.search = this.search
        payload.limit = this.pageLimitSet
        console.log(payload.limit, this.sorting_obj)
        const { data } = await fetchQuestionBank(
          customerId,
          payload,
          this.meta.current_page,
          this.sorting_obj
        )

        const question_details = data.data.question_details
        // this.question_details.forEach({

        // })

        this.question_details = data.data.question_details
        this.rowData = this.question_details
        console.log(this.question_details)
        this.rowData = this.rowData.map((row, index) => {
          row.row_index = index + 1
          return row
        })
        this.meta = data.data.meta
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    deleteQuestion (id) {},
    openConfirm (id, singleQuestionObject) {
      if (singleQuestionObject.status === true) {
        this.$vs.notify({
          title: 'Error',
          text: 'Active question can not be deleted',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      } else {
        this.delete_id.length = 0
        this.delete_id[0] = id

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure, you want to delete this question?',
          accept: this.acceptAlert
        })
      }
    },

    acceptAlert () {
      this.questionDelete(this.delete_id)
    },

    bulkDelete () {
      let count = 0
      this.selected = this.getSelectedRows()
      this.selected.forEach(ele => {
        if (ele.status === true) {
          count = 1
        }
      })

      if (count === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'All the selected records should be deactivated first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure, you want to delete all this question?',
          accept: this.bulkAlertDelete
        })
      }
    },

    bulkAlertDelete () {
      this.delete_id = this.selected.map(function (ele) {
        return ele.id
      })

      this.questionDelete(this.delete_id)
    },

    async questionDelete (deleteid) {
      try {
        const customerId = this.$store.getters.customerId
        const payload = {
          ids: this.delete_id
        }
        const data = await deleteQuestionById(customerId, payload)

        // const deleteIndex = this.question_details.findIndex(element => element.id === id)

        // this.question_details.splice(deleteIndex, 1)

        this.$vs.notify({
          title: 'Success',
          text: 'Question is deleted from the question bank',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        for (const delete_id of this.delete_id) {
          for (let i = 0; i < this.question_details.length; i++) {
            //
            if (delete_id === this.question_details[i].id) {
              this.question_details.splice(i, 1)
              // break
            }
          }
        }

        if (this.question_details.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }
      } catch (e) {}
    },
    handlePageChange (page) {
      this.selected.length = 0
      this.meta.current_page = page
      this.fetchQuestionBankList()
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({ path: '/pages/questionbanklist', query: {page:this.meta.current_page}  }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
    },
    async changeStatus (status, id, index) {
      try {
        this.$vs.loading()

        const customerId = this.$store.getters.customerId

        const objpayload = {
          ids: [id],
          status: !status
        }
        const data = await changeQuestionStatusById(customerId, objpayload)
        this.question_details[index].status = !status
        this.$vs.notify({
          title: 'Success',
          text: 'Status changed Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        this.question_details[index].status = status
      } finally {
        this.$vs.loading.close()
      }
    },
    sharingQuestion (questionId, sharedUserList) {
      this.sharedQuestionId = questionId
      this.sharedUserList = sharedUserList
      this.sharePopUp = true
    },
    updateUserId (userId) {
      const index = this.question_details.findIndex(
        element => element.id === this.sharedQuestionId
      )

      //   sharedUserList": [
      // {
      //   "to_user_id": 229
      // },
      const to_user_id = userId.map(eachUser => {
        return {
          to_user_id: eachUser
        }
      })
      this.question_details[index].sharedUserList = to_user_id
    }
  }
}
</script>
